module.exports = "<div style=\"margin:auto; text-align: center;\">\n    <h1 style=\"color: whitesmoke\">404</h1>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/layouts/not-found.template.html
// module id = 1395
// module chunks = 9